import Qs from 'qs';
import { rdc, deviceInventoryService } from '@saucelabs/sl-util-axios';

export const fetchPrivateDevices = (payload) => rdc.get('/device-management/devices', {
  params: payload,
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const fetchDevicesToTeams = (payload) => deviceInventoryService.get('/v1/rdc/teams-devices', {
  params: payload,
});

export const assignDeviceToTeam = ({ teamId, deviceDescriptorId }) => rdc.put(`/device-management/devices/${deviceDescriptorId}/team`, {
  id: teamId,
});

export const unAssignDeviceFromTeam = ({ deviceDescriptorId }) => rdc.delete(`/device-management/devices/${deviceDescriptorId}/team`);

export const updateDeviceSettings = (payload) => rdc.put(`/device-management/devices/${payload.id}/settings`, payload);
